import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { QrContentKey } from 'src/app/business/qr-create/qr-create-bean';
import { NavigationService } from 'src/app/system/utility/navigation.service';

/**
 * Temporary store for a qr-code deep link key. Kept across login until it is handed to qrContentRetrieve.
 * PEER / MERCHANT / EFT all resume on /qr-payment; that screen branches by type after retrieve.
 */
@Injectable({
  providedIn: 'root'
})
export class QrDeepLinkService {

  private static readonly RESUME_URL: string = '/qr-payment';

  private pendingKey: QrContentKey | null = null;

  constructor(private readonly router: Router) { }

  /**
   * Stash the key and open Send Money. Logged-out users are sent to login by NeedLoginGuard and resume via resolvePostLoginUrl.
   */
  public open(key: QrContentKey): void {
    this.pendingKey = key;

    if (this.router.url.includes(QrDeepLinkService.RESUME_URL)) {
      void NavigationService.gotoViaActivityReload(QrDeepLinkService.RESUME_URL);
    } else {
      void NavigationService.goto(this.router, QrDeepLinkService.RESUME_URL);
    }
  }

  public hasPending(): boolean {
    return this.pendingKey != null;
  }

  /**
   * Hand the key to qrContentRetrieve. The stash is cleared so the same link cannot be retrieved twice.
   */
  public take(): QrContentKey | null {
    let key = this.pendingKey;
    this.pendingKey = null;
    return key;
  }

  public resolvePostLoginUrl(url: string): string {
    return this.hasPending() ? QrDeepLinkService.RESUME_URL : url;
  }
}
